import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { ApiService } from 'src/app/api.service';
import { CreateUserComponent } from '../create-user/create-user.component';
import {MatTableDataSource} from '@angular/material/table';
import { ConformationComponent } from '../conformation/conformation.component';

export interface UserData {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  company_id: number;
  authorization: string;
  roles: [];
  created_at: string;
  updated_at: string;
  division: string;
}

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserManagementComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[];
  dataSource :any;

  showSpinner = false;
  searchText;
  public roles = ["admin", "manager","member", "user"];
  public filterRole = ["All","Root", "Admin", "Manager","Member", "User"];
  selectedCompanyId;
  role;
  screenwidth =null;
  dialogwidth = null;
  UserList = [];
  filterUserList1;
  filterUserList ;
  roleBasedFilterUserList = [];
  companyList = [];
  selectedCompany;
  selectedCompanyFilter;
  slelcted;
  selectedRole = [];
  selectedCompanyForFilter;
  userInfo = JSON.parse(localStorage.getItem('User'));
  userRole = this.userInfo.roles[0];
  disableCompanyDropdown = false;
  tabs = ['Create User', 'Filter Users'];
  selectedTab = 0;
  activTab = 'Create User';
  usertoEdit;
  
  constructor(
    private dialog: MatDialog,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
  ) {
    
  }

  // ngAfterViewInit() {
  //   this.filterUserList.paginator = this.paginator;
  //   this.filterUserList.sort = this.sort;
  // }

  ngOnInit(): void {
    this.screenwidth = screen.width;
    if(this.screenwidth < 500){
      this.dialogwidth = '90%';
    }else{
      this.dialogwidth = '50%';
    }
    if(this.userRole == 'root'){
      this.roles = ["root", "admin", "manager"];
    }

    if(this.userRole =='admin' || this.userRole =='root'){
      this.displayedColumns = ['first_name', 'last_name','email','phone','division','id','created_at', 'roles'];
    }else if(this.userRole =='manager'){
      this.displayedColumns = ['first_name', 'last_name','email','phone','division', 'roles'];
    }
    
    this.refreshUserList();

  }

  refreshUserList(){
    let data = {};
    if(this.userRole == 'root'){
        data = {"roles":[
          "root"
        ]};
      //   data = {"roles": [
      // ]};
      this.showSpinner = true;
      this._apiService.getCompanyList().subscribe(res => {
        if (res) {
          this.companyList = res;
          this.showSpinner = false;
          console.log(this.companyList);
        }
      },
      (error)=>{
        this.showSpinner = false;
      });
    }else if(this.userRole == 'admin' || this.userRole == 'manager'){
    data = {"roles":[ ]};
    this.selectedCompanyId = this.userInfo.company_id;
    }
    this.showSpinner = true;
    this._apiService.getUserList(data).subscribe(res => {
      if (res) {
        this.UserList = res;
        this.filterUserList = res;
        this.roleBasedFilterUserList = this.UserList;
        this.dataSource = new MatTableDataSource<UserData>(res);
        console.log(this.dataSource)
        setTimeout(() => this.dataSource.paginator = this.paginator);
        setTimeout(() => this.dataSource.sort = this.sort);
        this.showSpinner = false;
        console.log(this.filterUserList);
      }
    },
    (error)=>{
      this.showSpinner = false;
    });
  }

  onSelectcompany(event){
    this.selectedCompanyId=event.value.id;
    this.selectedCompanyFilter = event.value;
  }

  handleEdit(UserInfotoEdit){
    this.usertoEdit = UserInfotoEdit;
    this.openDialog('edit');
  }

  openDialog(type): void {
    const dialogRef = this.dialog.open(CreateUserComponent, {
      width: this.dialogwidth,
      data: {companyId: this.selectedCompanyId, role: this.selectedRole, type:type, usertoEdit:this.usertoEdit}
    });

    dialogRef.afterClosed().subscribe(result => {
      debugger;
      if(this.selectedCompanyFilter && this.userRole == 'root'){
        this.showSpinner = true;
        setTimeout(() => {
          if(this.selectedRole[0] == 'root'){
            this.refreshUserList();
          }else{
            this.onSelectcompanyFilter();
            this.selectedTab = 1;
            this.activTab = 'Filter Users';
          }
        
        }, 2000);
      }
      if(this.userRole == 'admin'){
        setTimeout(() => {
          this.refreshUserList();
          }, 1500);
      }
      
    });
    
  }

  deleteUser(data){
    const dialogRef = this.dialog.open(ConformationComponent, {
      width: '20rem',
      data: {id: data.id,type:'User'}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.refreshUserList();
    });
    
  
  }

  getCompanySpecificUserInfo(){
    let data = {};
    if(this.userRole == 'root'){
        // data = {"roles":[
        //   "admin"
        // ]};
        data = {"roles": [
      ]};
      this.showSpinner = true;
      this._apiService.getCompanyList().subscribe(res => {
        if (res) {
          this.companyList = res;
          this.showSpinner = false;
          console.log(this.companyList);
        }
      },
      (error)=>{
        this.showSpinner = false;
      });
    }else if(this.userRole == 'admin' || this.userRole == 'manager'){
    data = {"roles":[ ]};
    this.selectedCompanyId = this.userInfo.company_id;
    }
    this.showSpinner = true;
    this._apiService.getUserList(data).subscribe(res => {
      if (res) {
        this.UserList = res;
        this.filterUserList = res;
        this.dataSource = new MatTableDataSource<UserData>(res);
        setTimeout(() => this.dataSource.paginator = this.paginator);
        setTimeout(() => this.dataSource.sort = this.sort);
        this.roleBasedFilterUserList = this.UserList;
        this.showSpinner = false;
        console.log(this.filterUserList);
      }
    },
    (error)=>{
      this.showSpinner = false;
    });
  }

  

  updateUser(user){
    let userDataToUpdate = {
      "id":user.id, 
      "roles":user.roles
    };
    this.showSpinner = true;
    this._apiService.updateUser(userDataToUpdate).subscribe(res => {
      if (res) {
        console.log(res);
        this.refreshUserList();
        this.showSpinner = false;
      }
    },
    (error)=>{
      this.showSpinner = false;
    });
  }

  onSelectFilterUser(e){
    if(e.value == 'All'){
      this.filterUserList = this.UserList;
      this.dataSource = new MatTableDataSource<UserData>(this.UserList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.roleBasedFilterUserList = this.UserList;
    }else{
      let fitlered_users = this.UserList.filter(ele => ele.roles[0].includes(e.value.toLowerCase()));
      this.filterUserList = fitlered_users;
      this.dataSource = new MatTableDataSource<UserData>(fitlered_users);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.roleBasedFilterUserList = fitlered_users;
    }
  }

  onSelectCeateUser(e){
    
    if(e.value.toLowerCase() == 'root'){
      this.disableCompanyDropdown = true;
      this.selectedCompanyForFilter = this.companyList[0];
      this.selectedCompanyFilter = this.companyList[0];
      this.selectedCompanyId = this.companyList[0].id;
      this.selectedRole = ['root'];
    }else{
      this.selectedRole = [e.value.toLowerCase()];
      this.selectedCompanyForFilter = '';
      this.disableCompanyDropdown = false;
    }
  }

  onSearch(e){
    if(e == null){
      this.filterUserList = this.roleBasedFilterUserList;
      this.dataSource = new MatTableDataSource<UserData>(this.roleBasedFilterUserList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
    this.filterUserList = this.roleBasedFilterUserList.filter(ele => ele.first_name.toLowerCase().includes(e.toLowerCase()));
    this.dataSource = new MatTableDataSource<UserData>(this.filterUserList);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  onSelectcompanyFilter(){
    debugger;
    let data ;
    if(this.userRole == 'root'){
        if(this.selectedCompanyFilter.id == this.companyList[0].id){
          this.roles = ["root", "admin", "manager"];
        }else{
          this.roles = ["admin", "manager"];
        }
      data = {company_id:this.selectedCompanyFilter.id ,"roles":["admin"]};
    }else{
      data = {company_id:this.selectedCompanyFilter.id ,"roles":[]}
    }
    this.showSpinner = true;
    this._apiService.getUserList(data).subscribe(res => {
      if (res) {
        this.UserList = res;
        this.filterUserList = res;
        this.dataSource = new MatTableDataSource<UserData>(res);
        setTimeout(() => this.dataSource.paginator = this.paginator);
        setTimeout(() => this.dataSource.sort = this.sort);
        this.roleBasedFilterUserList = this.UserList;
        this.showSpinner = false;
        console.log(this.filterUserList);
      }
    },
    (error)=>{
      this.showSpinner = false;
    });
  }

  tabChanged(event){
    this.activTab = event.tab.textLabel;
    this.selectedCompanyFilter = '';
    console.log(event);
    if(event.tab.textLabel == 'Create User'){
      this.selectedTab = 0;
      this.refreshUserList();
      this.selectedCompanyFilter = '';
      if(this.userRole == 'root'){
        this.roles = ["root", "admin", "manager"];
      }else{
        this.roles = ["admin", "manager","member", "user"];
      }
    }
  }
}
